import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  createSpamAllowListError,
  createSpamAllowListSuccess,
  getSpamAllowListError,
  getSpamAllowListSuccess,
} from './actions'
import {
  CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC,
  FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC,
} from './constants'

const getAllowListEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.settings.community)
      }
      return true
    })
    .mergeMap(() =>
      api.settings
        .getSpamAllowList(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getSpamAllowListSuccess(response))
        .catch((error) =>
          Observable.of(
            addToast({
              type: 'error',
              message: 'Something went wrong. Please try again',
            }),
            epicsErrorHandler(getSpamAllowListError, error)
          )
        )
        .takeUntil(action$.ofType(FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL))
    )

const createAllowListEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE).mergeMap(() =>
      api.settings
        .createSpamAllowList(
          store.getState().settings.intelligence.spamAllowList.emailsList,
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) => createSpamAllowListSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(createSpamAllowListError, error)))
        .takeUntil(action$.ofType(CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL))
    )

export default combineEpics(getAllowListEpic, createAllowListEpic)
